/**
 * Country SEO i18n — Wave 9
 * Fills remaining language gaps for: Morocco, Tunisia, Senegal, Ivory Coast,
 * Cameroon, Ghana, Tanzania, Rwanda, Uganda, Mozambique, Algeria
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE9: CountrySEOMap = {

  // Fill gaps for Morocco
  morocco: {
    sv: {
      title: 'Callcenter Marocko | Franskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Marocko: franska/arabiska, CET-tidszon, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Marocko — Franskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på franska och arabiska.',
    },
    da: {
      title: 'Callcenter Marokko | Fransktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Marokko: fransk/arabisk, CET-tidszone, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Marokko — Fransktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice på fransk og arabisk.',
    },
    ko: {
      title: '모로코 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '모로코 콜센터: 프랑스어/아랍어, CET 시간대, CSAT 95%, 시간당 3달러부터. 70% 절감.',
      heroTitle: '모로코 콜센터 — 프랑스어 고객 서비스',
      heroSubtitle: '프랑스어 및 아랍어 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'モロッココールセンター | フランス語カスタマーサービス | Call IT Dev',
      description: 'モロッコ向けコールセンター: フランス語/アラビア語、CET時間帯、CSAT 95%、3$/時間〜。70%削減。',
      heroTitle: 'モロッコ向けコールセンター — フランス語カスタマーサービス',
      heroSubtitle: 'フランス語とアラビア語のプレミアムサポート。',
    },
  },

  // Fill gaps for Tunisia
  tunisia: {
    sv: {
      title: 'Callcenter Tunisien | Franskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Tunisien: franska/arabiska, CET-tidszon, CSAT 95%, från 3 $/h. 65% besparing.',
      heroTitle: 'Callcenter för Tunisien — Franskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst från Nordafrika.',
    },
    da: {
      title: 'Callcenter Tunesien | Fransktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Tunesien: fransk/arabisk, CET-tidszone, CSAT 95%, fra 3 $/t. 65% besparelse.',
      heroTitle: 'Callcenter til Tunesien — Fransktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice fra Nordafrika.',
    },
    ko: {
      title: '튀니지 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '튀니지 콜센터: 프랑스어/아랍어, CET, CSAT 95%, 시간당 3달러부터. 65% 절감.',
      heroTitle: '튀니지 콜센터 — 프랑스어 고객 서비스',
      heroSubtitle: '북아프리카에서 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'チュニジアコールセンター | フランス語カスタマーサービス | Call IT Dev',
      description: 'チュニジア向けコールセンター: フランス語/アラビア語、CET、CSAT 95%、3$/時間〜。65%削減。',
      heroTitle: 'チュニジア向けコールセンター — フランス語カスタマーサービス',
      heroSubtitle: '北アフリカからプレミアムサポート。',
    },
  },

  // Fill gaps for Senegal
  senegal: {
    sv: {
      title: 'Callcenter Senegal | Franskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Senegal: franska, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Senegal — Franskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst från Västafrika.',
    },
    da: {
      title: 'Callcenter Senegal | Fransktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Senegal: fransk, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Senegal — Fransktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice fra Vestafrika.',
    },
    ko: {
      title: '세네갈 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '세네갈 콜센터: 프랑스어, CSAT 95%, 시간당 3달러부터. 70% 절감.',
      heroTitle: '세네갈 콜센터 — 프랑스어 고객 서비스',
      heroSubtitle: '서아프리카에서 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'セネガルコールセンター | フランス語カスタマーサービス | Call IT Dev',
      description: 'セネガル向けコールセンター: フランス語、CSAT 95%、3$/時間〜。70%削減。',
      heroTitle: 'セネガル向けコールセンター — フランス語カスタマーサービス',
      heroSubtitle: '西アフリカからプレミアムサポート。',
    },
  },

  // Fill gaps for Ivory Coast
  ivoryCoast: {
    sv: {
      title: 'Callcenter Elfenbenskusten | Franskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Elfenbenskusten: franska, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Elfenbenskusten — Franskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst från Västafrika.',
    },
    da: {
      title: 'Callcenter Elfenbenskysten | Fransktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Elfenbenskysten: fransk, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Elfenbenskysten — Fransktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice fra Vestafrika.',
    },
    ko: {
      title: '코트디부아르 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '코트디부아르 콜센터: 프랑스어, CSAT 95%, 시간당 3달러부터. 70% 절감.',
      heroTitle: '코트디부아르 콜센터 — 프랑스어 고객 서비스',
      heroSubtitle: '서아프리카에서 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'コートジボワールコールセンター | フランス語カスタマーサービス | Call IT Dev',
      description: 'コートジボワール向けコールセンター: フランス語、CSAT 95%、3$/時間〜。70%削減。',
      heroTitle: 'コートジボワール向けコールセンター — フランス語カスタマーサービス',
      heroSubtitle: '西アフリカからプレミアムサポート。',
    },
  },

  // Fill gaps for Cameroon
  cameroon: {
    sv: {
      title: 'Callcenter Kamerun | Tvåspråkig Kundtjänst FR/EN | Call IT Dev',
      description: 'Outsourca callcenter till Kamerun: franska/engelska, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Kamerun — Tvåspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på franska och engelska.',
    },
    da: {
      title: 'Callcenter Cameroun | Tosproget Kundeservice FR/EN | Call IT Dev',
      description: 'Outsource callcenter til Cameroun: fransk/engelsk, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Cameroun — Tosproget Kundeservice',
      heroSubtitle: 'Premium kundeservice på fransk og engelsk.',
    },
    ko: {
      title: '카메룬 콜센터 | 이중 언어 고객 서비스 FR/EN | Call IT Dev',
      description: '카메룬 콜센터: 프랑스어/영어, CSAT 95%, 시간당 3달러부터. 70% 절감.',
      heroTitle: '카메룬 콜센터 — 이중 언어 고객 서비스',
      heroSubtitle: '프랑스어 및 영어 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'カメルーンコールセンター | バイリンガルカスタマーサービス FR/EN | Call IT Dev',
      description: 'カメルーン向けコールセンター: フランス語/英語、CSAT 95%、3$/時間〜。70%削減。',
      heroTitle: 'カメルーン向けコールセンター — バイリンガルカスタマーサービス',
      heroSubtitle: 'フランス語と英語のプレミアムサポート。',
    },
  },

  // Fill gaps for Ghana
  ghana: {
    sv: {
      title: 'Callcenter Ghana | Engelskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Ghana: engelsktalande, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Ghana — Engelskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst från Västafrika.',
    },
    da: {
      title: 'Callcenter Ghana | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Ghana: engelsktalende, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Ghana — Engelsktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice fra Vestafrika.',
    },
    ko: {
      title: '가나 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '가나 콜센터: 영어, CSAT 95%, 시간당 3달러부터. 70% 절감.',
      heroTitle: '가나 콜센터 — 영어 고객 서비스',
      heroSubtitle: '서아프리카에서 프리미엄 영어 고객 서비스.',
    },
    ja: {
      title: 'ガーナコールセンター | 英語カスタマーサービス | Call IT Dev',
      description: 'ガーナ向けコールセンター: 英語、CSAT 95%、3$/時間〜。70%削減。',
      heroTitle: 'ガーナ向けコールセンター — 英語カスタマーサービス',
      heroSubtitle: '西アフリカからプレミアム英語サポート。',
    },
  },

  // Fill gaps for Tanzania
  tanzania: {
    sv: {
      title: 'Callcenter Tanzania | Engelskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Tanzania: engelska/swahili, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Tanzania — Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för Östafrika.',
    },
    da: {
      title: 'Callcenter Tanzania | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Tanzania: engelsk/swahili, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Tanzania — Kundeservice',
      heroSubtitle: 'Premium kundeservice til Østafrika.',
    },
    ko: {
      title: '탄자니아 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '탄자니아 콜센터: 영어/스와힐리어, CSAT 95%, 시간당 3달러부터. 70% 절감.',
      heroTitle: '탄자니아 콜센터 — 고객 서비스',
      heroSubtitle: '동아프리카를 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'タンザニアコールセンター | 英語カスタマーサービス | Call IT Dev',
      description: 'タンザニア向けコールセンター: 英語/スワヒリ語、CSAT 95%、3$/時間〜。70%削減。',
      heroTitle: 'タンザニア向けコールセンター — カスタマーサービス',
      heroSubtitle: '東アフリカ向けプレミアムサポート。',
    },
  },

  // Fill gaps for Rwanda
  rwanda: {
    sv: {
      title: 'Callcenter Rwanda | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Rwanda: franska/engelska, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Rwanda — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för Östafrika.',
    },
    da: {
      title: 'Callcenter Rwanda | Flersproget Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Rwanda: fransk/engelsk, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Rwanda — Flersproget Kundeservice',
      heroSubtitle: 'Premium kundeservice til Østafrika.',
    },
    ko: {
      title: '르완다 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '르완다 콜센터: 프랑스어/영어, CSAT 95%, 시간당 3달러부터. 70% 절감.',
      heroTitle: '르완다 콜센터 — 다국어 고객 서비스',
      heroSubtitle: '동아프리카를 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'ルワンダコールセンター | 多言語カスタマーサービス | Call IT Dev',
      description: 'ルワンダ向けコールセンター: フランス語/英語、CSAT 95%、3$/時間〜。70%削減。',
      heroTitle: 'ルワンダ向けコールセンター — 多言語カスタマーサービス',
      heroSubtitle: '東アフリカ向けプレミアムサポート。',
    },
  },

  // Fill gaps for Kuwait
  kuwait: {
    sv: {
      title: 'Callcenter Kuwait | Arabisk & Engelsk Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Kuwait: arabiska/engelska, CSAT 95%, från 5 $/h. 65% besparing.',
      heroTitle: 'Callcenter för Kuwait — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för GCC-marknaden.',
    },
    da: {
      title: 'Callcenter Kuwait | Arabisk & Engelsk Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Kuwait: arabisk/engelsk, CSAT 95%, fra 5 $/t. 65% besparelse.',
      heroTitle: 'Callcenter til Kuwait — Flersproget Kundeservice',
      heroSubtitle: 'Premium kundeservice til GCC-markedet.',
    },
    ko: {
      title: '쿠웨이트 콜센터 | 아랍어 & 영어 고객 서비스 | Call IT Dev',
      description: '쿠웨이트 콜센터: 아랍어/영어, CSAT 95%, 시간당 5달러부터. 65% 절감.',
      heroTitle: '쿠웨이트 콜센터 — 다국어 고객 서비스',
      heroSubtitle: 'GCC 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'クウェートコールセンター | アラビア語・英語カスタマーサービス | Call IT Dev',
      description: 'クウェート向けコールセンター: アラビア語/英語、CSAT 95%、5$/時間〜。65%削減。',
      heroTitle: 'クウェート向けコールセンター — 多言語カスタマーサービス',
      heroSubtitle: 'GCC市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Bahrain
  bahrain: {
    sv: {
      title: 'Callcenter Bahrain | Arabisk & Engelsk Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Bahrain: arabiska/engelska, CSAT 95%, från 5 $/h. 65% besparing.',
      heroTitle: 'Callcenter för Bahrain — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för GCC-marknaden.',
    },
    da: {
      title: 'Callcenter Bahrain | Arabisk & Engelsk Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Bahrain: arabisk/engelsk, CSAT 95%, fra 5 $/t. 65% besparelse.',
      heroTitle: 'Callcenter til Bahrain — Flersproget Kundeservice',
      heroSubtitle: 'Premium kundeservice til GCC-markedet.',
    },
    ko: {
      title: '바레인 콜센터 | 아랍어 & 영어 고객 서비스 | Call IT Dev',
      description: '바레인 콜센터: 아랍어/영어, CSAT 95%, 시간당 5달러부터. 65% 절감.',
      heroTitle: '바레인 콜센터 — 다국어 고객 서비스',
      heroSubtitle: 'GCC 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'バーレーンコールセンター | アラビア語・英語カスタマーサービス | Call IT Dev',
      description: 'バーレーン向けコールセンター: アラビア語/英語、CSAT 95%、5$/時間〜。65%削減。',
      heroTitle: 'バーレーン向けコールセンター — 多言語カスタマーサービス',
      heroSubtitle: 'GCC市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Oman
  oman: {
    sv: {
      title: 'Callcenter Oman | Arabisk & Engelsk Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Oman: arabiska/engelska, CSAT 95%, från 5 $/h. 65% besparing.',
      heroTitle: 'Callcenter för Oman — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för GCC-marknaden.',
    },
    da: {
      title: 'Callcenter Oman | Arabisk & Engelsk Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Oman: arabisk/engelsk, CSAT 95%, fra 5 $/t. 65% besparelse.',
      heroTitle: 'Callcenter til Oman — Flersproget Kundeservice',
      heroSubtitle: 'Premium kundeservice til GCC-markedet.',
    },
    ko: {
      title: '오만 콜센터 | 아랍어 & 영어 고객 서비스 | Call IT Dev',
      description: '오만 콜센터: 아랍어/영어, CSAT 95%, 시간당 5달러부터. 65% 절감.',
      heroTitle: '오만 콜센터 — 다국어 고객 서비스',
      heroSubtitle: 'GCC 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'オマーンコールセンター | アラビア語・英語カスタマーサービス | Call IT Dev',
      description: 'オマーン向けコールセンター: アラビア語/英語、CSAT 95%、5$/時間〜。65%削減。',
      heroTitle: 'オマーン向けコールセンター — 多言語カスタマーサービス',
      heroSubtitle: 'GCC市場向けプレミアムサポート。',
    },
  },
};
